import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official'; // Or use @highcharts/react components
import 'highcharts/modules/exporting';
import { Typography } from '@mui/material';
import { formatNumber } from '../../../../../Common/FormatNumber';

interface ChartProps {
  data: number[];
  categories: string[];
  title: string;
  height: number;
}

const LineChart: React.FC<ChartProps> = ({ data, categories, title, height = 345 }) => {
  const chartComponentRef = React.useRef<HighchartsReact.RefObject>(null);
  React.useEffect(() => {
    const handleResize = () => {
      if (chartComponentRef.current && chartComponentRef.current.chart) {
        chartComponentRef.current.chart.reflow();
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const options: Highcharts.Options = {
    chart: {
      style: {
        fontFamily: 'inherit',
      },
      zooming: {
        type: 'xy' as const
      }
    },
    title: {
        text: title,
        align: 'left'
    },

    yAxis: {
        title: {
            text: 'Sales ($)',
            style: {
                fontFamily: 'Trebuchet MS'
            }
        },
        labels: {
            formatter: function(this: Highcharts.AxisLabelsFormatterContextObject) {
                const v = this.value as number;
                const absv = Math.abs(v);
                if (absv >= 1000000) return v / 1000000 + 'M';
                if (absv >= 1000) return v / 1000 + 'K';
                return String(v);
            },
            style: {
                fontFamily: 'Trebuchet MS'
            }
        },
        startOnTick: true,
        endOnTick: true,
        showLastLabel: true
    },

    xAxis: {
        categories: categories,
        labels: {
            style: {
                fontFamily: 'Trebuchet MS'
            }
        }
    },

    // legend: {
    //     layout: 'vertical',
    //     align: 'right',
    //     verticalAlign: 'middle'
    // },

    plotOptions: {
        series: {
            label: {
                connectorAllowed: false
            },
            // pointStart: 2010
        },
    },

    tooltip: {
        formatter: function(this: Highcharts.Point) {
          return `<b>${this.series.name}</b><br><span style="font-family: Trebuchet MS;">${this.category}: ${formatNumber(this.y, 'en-US', 'USD')}</span>`;
        }
    },

    exporting: {
        enabled: true, // Enable the export menu
        buttons: {
            contextButton: {
                menuItems: [
                    'downloadPNG',
                    'downloadJPEG',
                    'downloadPDF',
                    'downloadSVG',
                    'separator',
                    'printChart',
                ],
            },
        },
    },

    series: [
      {
        type: 'line', // Specify the chart type
        name: 'Monthly Sales',
        data: data,
      },
    ],
  };

  return (
    <div style={{ height: '100%', width: '100%' }}>
      {data.length > 0 ? (
        <HighchartsReact
          highcharts={Highcharts}
          options={options}
          allowChartUpdate={true}
          exportEnabled={true}
          ref={chartComponentRef}
          containerProps={{ style: { width: '100%', height: height, border: 'none', borderRadius: 5, boxShadow: 'none', margin: 0, padding: 0 } }}
        />
      ) : (
        <Typography variant="body1" sx={{ color: 'text.secondary', textAlign: 'center' }}>No data available</Typography>
      )}
    </div>
  );
};

export default LineChart;